// extracted by mini-css-extract-plugin
export default {"mainContainer":"SalesTables_mainContainer__9ckXd","table":"SalesTables_table__bM58F"};